<template>
  <div id="SlowMovingLocations">
    <button v-show="!isLoading" class="button-filled mt-2 mb-1 my-auto float-right" id="openModalAdd" @click="openReportModal"><font-awesome-icon icon="plus" class="icon" /></button>
    <h1 class="brand-color-dark headline">Langsamfahrstellen</h1>
    
    <NoDataBox v-if="data.length <= 0 && !isLoading" headline="Keine Informationen vorhanden">Schaue später wieder vorbei.</NoDataBox>

    <p v-show="isLoading">
      <font-awesome-icon icon="spinner" class="icon" pulse /> Daten werden geladen...
    </p>

    <ModalBoardReport v-show="isModalVisible" @close="closeModal" :data="modalData" />
    <ModalBoardReportCreator v-if="isReportModalVisible" @close="closeReportModal" />

    <div class="content-card-container grid grid-cols-1 md:grid-cols-2 gap-x-2 sm:gap-x-2 gap-y-4 my-3  items-stretch" v-if="data">
      <SlowMovingLocationItem @openReportModal="showModal" :reportable="true" :data="d" v-for="d in data.data"  :key="d.id"></SlowMovingLocationItem>
    </div>
  </div>
</template>


<script>
import NoDataBox from "@/components/NoDataBox";
import SlowMovingLocationItem from "@/components/SlowMovingLocationItem";
import ModalBoardReport from "@/components/ModalBoardReport";
import ModalBoardReportCreator from "@/components/ModalBoardReportCreator";

import { mapGetters } from "vuex";

export default {
  name: "SlowMovingLocations",
  components: {
    NoDataBox,
    SlowMovingLocationItem,
    ModalBoardReport,
    ModalBoardReportCreator
  },
  data() {
    return {
      data: [],
      isLoading: true,
      isReportModalVisible: false,
      isModalVisible: false,
      modalData: null,
    };
  },
  methods: {
    openReportModal(data) {
      this.isReportModalVisible = true;
      document.body.classList.add("modal-open");
    },
    closeReportModal(data) {
      this.isReportModalVisible = false;
      document.body.classList.remove("modal-open");
    },
    showModal(data) {
      this.modalData = data
      this.isModalVisible = true;
      document.body.classList.add("modal-open");
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.classList.remove("modal-open");
    },
  },
  mounted() {
    this.$store.dispatch("fetchUserProfile");

    this.$store.dispatch("fetchSpeedlimits").then((a) => {
      if (a.status == true) {
        this.data = a.result
      }

      this.isLoading = false
    });
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    }),
  },
};
</script>